import { useContext, useEffect, useState } from 'react'
import { useRouter } from 'next/router'
import { PropertiesContext } from 'context/propertiesContext'
import qs from  'qs'
import styles from './pagination.module.css'


const MAX_BUTTONS = 3
const MAX_LEFT = (MAX_BUTTONS - 1) / 2

export default function Pagination() {
  const [query, setQuery] = useState('')
  const { page, numberProperties } = useContext(PropertiesContext)

  const total_pages = Math.ceil(numberProperties / 9)
  const first = Math.max(page - MAX_LEFT, 1)
  const last = Math.max(total_pages - (MAX_BUTTONS -1), 1)

  const router = useRouter()
  
  useEffect(() => {
    setQuery(qs.stringify(router.query))
  }, [router.query])

  return (
    <>
      <div className={styles.container}>
        <button
          onClick={() => router.push(
            query.length < 1 ?
            `?page=${page - 1}` :
            router.query.hasOwnProperty('page') ?
            `?${query.replace(`page=${page}`, `page=${page - 1}`)}` :
            `?${query}&page=${page - 1}`
          )}
          disabled={page <= 1}
        >
          Anterior
        </button>

        <ul className={styles.pagination}>
          {
            page === total_pages ? (
              Array.from({ length: Math.min(MAX_BUTTONS, total_pages) })
                .map((_, index) => index + last)
                .map((button_page) => (
                  <li key={button_page}>
                    <button
                      onClick={() => router.push(
                        query.length < 1 ?
                        `?page=${button_page}` :
                        router.query.hasOwnProperty('page') ?
                        `?${query.replace(`page=${page}`, `page=${button_page}`)}`:
                        `?${query}&page=${button_page}`
                      )}

                      className={button_page === page ? styles.active : null}
                    >
                      {button_page}
                    </button>
                  </li>
                ))
            ) : (
              Array.from({ length: Math.min(MAX_BUTTONS, total_pages) })
              .map((_, index) => index + first)
              .map((button_page) => (
                <li key={button_page}>
                  <button
                      onClick={() => router.push(
                        query.length < 1 ?
                        `?page=${button_page}` :
                        router.query.hasOwnProperty('page') ?
                        `?${query.replace(`page=${page}`, `page=${button_page}`)}`:
                        `?${query}&page=${button_page}`
                      )}

                      
                    className={button_page === page ? styles.active : null}
                  >
                    {button_page}
                  </button>
                </li>
              ))
            )
          }
        </ul>
        <button
          onClick={() => router.push(
            query.length < 1 ?
            `?page=${page + 1}` :
            router.query.hasOwnProperty('page') ?
            `?${query.replace(`page=${page}`, `page=${page + 1}`)}`:
            `?${query}&page=${page + 1}`
          )}
          disabled={page >= Math.ceil(numberProperties / 9)}
        >
          Próxima
        </button>
      </div>
    </>
  )
}
